import { HIGHLIGHT_COLORS } from "@/hooks/useBoardOrganization";

// Popover shown on right-click / focus of a highlightable cell.
// Renders as a small floating menu anchored to the given position.
export default function BoardHighlightPopover({ open, position, current, onPick, onClose }) {
  if (!open || !position) return null;
  return (
    <div
      className="board-highlight-popover"
      data-testid="board-highlight-popover"
      onClick={(event) => event.stopPropagation()}
      style={{
        position: "fixed",
        top: position.top,
        left: position.left,
        zIndex: 60,
        background: "#fff",
        border: "1px solid #e2e8f0",
        borderRadius: 8,
        boxShadow: "0 4px 20px rgba(15,23,42,0.15)",
        padding: 6,
        display: "flex",
        gap: 4,
      }}
    >
      {HIGHLIGHT_COLORS.map((c) => (
        <button
          aria-label={`Highlight ${c}`}
          data-testid={`board-highlight-color-${c}`}
          key={c}
          onClick={() => { onPick(c); onClose(); }}
          style={{
            width: 22, height: 22, borderRadius: 4,
            border: current === c ? "2px solid #0f172a" : "1px solid #e2e8f0",
            background: `var(--bo-${c}, ${c})`,
            cursor: "pointer",
          }}
          type="button"
        />
      ))}
      <button
        aria-label="Clear highlight"
        data-testid="board-highlight-color-clear"
        onClick={() => { onPick(null); onClose(); }}
        style={{
          width: 22, height: 22, borderRadius: 4,
          border: "1px solid #e2e8f0", background: "#fff",
          fontSize: 14, lineHeight: 1, cursor: "pointer",
        }}
        type="button"
      >
        ×
      </button>
    </div>
  );
}
